var map = {
	"./kanban-board/board": 63,
	"./kanban-board/board.vue": 63,
	"./kanban-board/components/Badge": 6389,
	"./kanban-board/components/Badge.vue": 6389,
	"./kanban-board/components/TaskCard": 4717,
	"./kanban-board/components/TaskCard.vue": 4717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;